import { Pagination } from '@/components/form/shared/pagination'
import { usePagination, useSetCurrentPage } from '../state/pagination'

export default function ListarUsuariosAllPagination() {
  const { currentPage, itemsPerPage, startIndex, endIndex } = usePagination()
  const setCurrentPage = useSetCurrentPage()

  return (
    <Pagination
      currentPage={currentPage}
      totalPages={itemsPerPage}
      startIndex={startIndex}
      endIndex={endIndex}
      totalItems={itemsPerPage}
      onPageChange={setCurrentPage}
    />
  )
}
